import { ComponentProps, ReactElement } from 'react';
import { Dayts, DaytsFormatEnum, getClasses, parsePhoneNumber } from '@/utils';
import { InvoiceHeader, RunPreviewInvoiceResponse } from '@/models/gen/graphql';

import InvoiceDetail from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetail';
import InvoicePdfDetailList from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetailList';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoiceDatesProps = ComponentProps<'ul'>;

const InvoiceDates = ({ ...props }: InvoiceDatesProps): ReactElement => {
  const { invoiced, startDatetime, endDatetime, id, invoiceTerms, due, headers, fax } = usePdfLayout(
    ({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
      // Terms
      invoiceTerms: state?.data?.invoiceTerms,
      headers: state?.data?.output?.headers,
      fax: state?.data?.output?.company?.invoiceFax,
      invoiced: state?.data?.output?.invoice?.invoiced,
      startDatetime: state?.data?.output?.invoice?.startDatetime,
      endDatetime: state?.data?.output?.invoice?.endDatetime,
      id: state?.data?.output?.invoice?.id,
      due: state?.data?.output?.invoice?.due,
    })
  );

  return (
    <InvoicePdfDetailList {...props} className={getClasses('InvoicePdf-Dates', props.className)}>
      <InvoiceDetail name="Invoice Date">{new Dayts(invoiced).formatAs(DaytsFormatEnum.DATE_FE)}</InvoiceDetail>
      <InvoiceDetail name="Billing Period">
        {[new Dayts(startDatetime).formatAs(DaytsFormatEnum.DATE_FE), new Dayts(endDatetime).formatAs(DaytsFormatEnum.DATE_FE)].join(' - ')}
      </InvoiceDetail>
      <InvoiceDetail name="Invoice Number">{id}</InvoiceDetail>
      <InvoiceDetail name="Invoice Terms">{invoiceTerms ?? 'N/A'}</InvoiceDetail>
      <InvoiceDetail name="Due Date">{new Dayts(due).formatAs(DaytsFormatEnum.DATE_FE)}</InvoiceDetail>
      {headers?.map(
        ({ name }: InvoiceHeader, index: number): ReactElement => (
          <InvoiceDetail className="InvoicePdf-Note" key={index}>
            {name}
          </InvoiceDetail>
        )
      )}
      <InvoiceDetail name="Note">SkyHop bills an uncontracted trip at the market rate.</InvoiceDetail>
      {fax && <InvoiceDetail name="Fax">{parsePhoneNumber(fax)}</InvoiceDetail>}
      <InvoiceDetail name="Payment">Payment waives any dispute to the charges.</InvoiceDetail>
    </InvoicePdfDetailList>
  );
};

export default InvoiceDates;
